var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.2496V16.6246M3.14653 20.5632C2.13503 22.3132 3.3997 24.4996 5.4192 24.4996H22.5809C24.5992 24.4996 25.8627 22.3132 24.8535 20.5632L16.2739 5.69289C15.2635 3.94172 12.7365 3.94172 11.7262 5.69289L3.14653 20.5632V20.5632ZM14 20.1246H14.0082V20.1339H14V20.1246Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.9a902193700cae93c9bb9b7f93482fbb.svg";
export { ForwardRef as ReactComponent };